import { brandCodeMap } from '@/constants';
import { comm, base } from '../base';
const layoutTheme = {};

// export const baseicLayout = {
//   // ...base,
//   // 侧边栏
//   sider: {
//     bgImg: base.bgImg.bg0001,
//   },
//   // 菜单项
//   menu: {
//     fontSize: base.fontSize.px16,
//     // bgColor: base.color.c0023,
//     linkColor: base.color.c0020,
//     linkHoverColor: comm.color.cffff,
//     seledBgColor: base.color.c0019,
//     seledColor: base.color.c0017,
//   },
//   // 弹出菜单
//   menuPop: {
//     bgColor: base.color.c0018,
//   },
//   // 菜单收缩开关
//   siderSwitch: {
//     bgColor: base.color.c0021,
//   },
//   // 右侧主内容布局
//   mainLayout: {
//     bgColor: base.color.c0022,
//     headerBgColor: comm.color.cffff,
//   },
//   //header切换语言
//   header: {
//     borderColor: base.color.c0030,
//     selectBgColor: base.color.c0007,
//     selectColor: comm.color.cffff,
//     unSelectBgColor: comm.color.cffff,
//     unSelectColor: comm.color.c0000,
//   },
// };
for (const item of Object.keys(brandCodeMap)) {
  layoutTheme[item] = {
    // ...base,
    // 右侧内容栏
    content: {
      bgImg: base[item]?.others.imgs.bg0001,
    },
    // 侧边栏
    sider: {
      bgImg: base[item]?.others.imgs.bg0001,
      // bcgImg:base[item]?.imgs.bg001,
    },
    // 菜单项
    menu: {
      fontSize: comm.fontSize.s04,
      // bgColor: base.color.c0023,
      linkColor: base[item]?.layoutColor.c0020,
      linkHoverColor: comm.color.cffff,
      seledBgColor: base[item]?.layoutColor.c0019,
      seledColor: base[item]?.layoutColor.c0017,
    },
    // 弹出菜单
    menuPop: {
      bgColor: base[item]?.layoutColor.c0018,
    },
    // 菜单收缩开关
    siderSwitch: {
      bgColor: base[item]?.layoutColor.c0021,
    },
    // 右侧主内容布局
    mainLayout: {
      bgColor: base[item]?.layoutColor.c0022,
      headerBgColor: comm.color.cffff,
    },
    //header切换语言
    header: {
      borderColor: base[item]?.layoutColor.c0030,
      selectBgColor: base[item]?.layoutColor.c0007,
      selectColor: comm.color.cffff,
      unSelectBgColor: comm.color.cffff,
      unSelectColor: comm.color.c0000,
    },
  };
}

export const baseicLayout = layoutTheme;
